import React, { useMemo } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';

import PaymentPage from '@views/Payments/PaymentPage';
import { OrderDetailsProvider, useOrderDetails } from '@hooks/useOrderDetails';
import { PaymentCompleteInfo } from '@views/Payments/PaymentCompleteInfo';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './PaymentConfirmation.json';
import { Button } from '@components';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
}));

const PaymentConfirmation = ({ location, orderId }) => {
  const classes = useStyles();
  const {
    total,
    balance,
    payments,
    hasPendingPayments,
    orderFetchCompleted,
    error,
  } = useOrderDetails(orderId);
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const isFullyPaid = !hasPendingPayments && balance.amount === 0;

  useMemo(() => {
    if (localStorage.getItem('microdepositVerificationUrl')) {
      handleClickOpen();
    }
  }, [localStorage.getItem('microdepositVerificationUrl')]);

  const topDescription = (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          className={classes.title}
          data-confirmation-title
        >
          {l(content.confirmation, language)}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={10}>
        <Typography variant="body2">
          {isFullyPaid
            ? l(content.fullSet, language)
            : l(content.partialSet, language)}
        </Typography>
      </Grid>
    </Grid>
  );

  const bottomContent = (
    <PaymentCompleteInfo info={l(content.emailConfirm, language)} />
  );

  return (
    <OrderDetailsProvider value={{ error, total, balance, payments }}>
      <PaymentPage
        location={location}
        topDescription={topDescription}
        bottomContent={bottomContent}
        isLoading={!orderFetchCompleted}
        orderId={orderId}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'The account needs to be verified via microdeposits.'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please verify the account via microdeposits to complete the payment
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            hoverColor="#555354"
            text={'Verify'}
            onClick={() => {
              window.open(
                localStorage.getItem('microdepositVerificationUrl'),
                '_blank'
              );
              localStorage.removeItem('microdepositVerificationUrl');
            }}
          />
          <Button hoverColor="#555354" text={'Close'} onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </OrderDetailsProvider>
  );
};

export default PaymentConfirmation;
